var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dynamic-document-machine-working-area-boundary-field-template',{attrs:{"field-config":_vm.fieldConfig.fieldType}}),_c('dynamic-document-screen-width-configuration-template',{attrs:{"field-config":_vm.fieldConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }